var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3575 3.75757C4.3575 4.96594 3.38625 5.94507 2.1875 5.94507C0.98875 5.94507 0.0175 4.96594 0.0175 3.75757C0.0175 2.55007 0.98875 1.57007 2.1875 1.57007C3.38625 1.57007 4.3575 2.55007 4.3575 3.75757ZM4.375 7.69507H0V21.6951H4.375V7.69507ZM11.3593 7.69507H7.01225V21.6951H11.3601V14.3459C11.3601 10.2597 16.6355 9.92544 16.6355 14.3459V21.6951H21V12.8304C21 5.93544 13.1933 6.18657 11.3593 9.58069V7.69507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bc2ce029044efc23d85a8eb6bffc2336.svg";
export { ForwardRef as ReactComponent };